<app-table
  *ngIf="cols && productId && fixedFilters"
  [cols]="cols"
  modelName="movimentações"
  sortField="dateCreated"
  [sortOrder]="1"
  [service]="productService"
  [findPage]="findPage"
  [addButton]="false"
  [dropdownFilters]="dropdownFilters"
  [fixedFilters]="fixedFilters"
  [changeColumns]="true"
/>
